export const SET_DATE_OF_BIRTH = "SET_DATE_OF_BIRTH";